import {
  GRID_TEE_FRAME_TOP_LEFT,
  GRID_TEE_FRAME_TOP_RIGHT,
  GridTee,
} from "@/components/ui/grid-connector";
import { cn } from "@/lib/utils";

import { PartnerCard } from "./partner-card";
import type { PartnerDirectoryCardData } from "./types";

interface DirectoryShellProps {
  sidebar: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

/**
 * Figma 12328:40755 — white bordered panel on grey-50: 217px filter rail beside
 * the card grid at lg, a single "Filters" bar above the grid below lg.
 */
export function DirectoryShell({
  sidebar,
  children,
  footer,
}: DirectoryShellProps) {
  return (
    <section
      data-testid="partner-directory"
      className="bg-grey-50 border-grey-100 border-b pb-10 lg:px-20 lg:pb-20"
    >
      <div className="bg-grey-0 border-grey-100 relative mx-auto flex w-full max-w-[1280px] flex-col border-y lg:flex-row lg:border-x">
        <GridTee
          className={cn(GRID_TEE_FRAME_TOP_LEFT, "z-10 hidden lg:block")}
        />
        <GridTee
          className={cn(GRID_TEE_FRAME_TOP_RIGHT, "z-10 hidden lg:block")}
        />
        <aside className="lg:w-[217px] lg:shrink-0">{sidebar}</aside>
        <div className="border-grey-100 min-w-0 flex-1 p-5 lg:border-l lg:p-8">
          {children}
        </div>
      </div>
      {footer}
    </section>
  );
}

interface DirectoryGridProps {
  partners: PartnerDirectoryCardData[];
  label: string;
  className?: string;
  ref?: React.Ref<HTMLUListElement>;
}

export function DirectoryGrid({
  partners,
  label,
  className,
  ref,
}: DirectoryGridProps) {
  return (
    <ul
      ref={ref}
      aria-label={label}
      className={cn(
        "grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3",
        className
      )}
    >
      {partners.map((partner) => (
        <PartnerCard key={partner.slug} partner={partner} />
      ))}
    </ul>
  );
}
